
import ILoginProps from "pages/Login/ILoginProps";
import { CustomButton, HrText } from "core/interfaces/components/index";
import "./Login.css";
import LoginForm from "components/LoginForm/LoginForm";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { Enhanced } from "utils/ReactUtils";

const Login: React.FC<ILoginProps> = ({ OnLogin, OnChangePasswordRequest, ChangeAuthenticationMode,t }) => {
	

	return (
		<div id="login" role="main" aria-label="login">
			<LoginForm OnLoginSuccess={OnLogin} OnChangePasswordRequest={OnChangePasswordRequest} />
			<HrText text={t("login.signUpHint")} />
			<div className="login-form-container">
				<div className="btnSignUp">
					<CustomButton
						text={t("login.signup")}
						style={{ width: "100%" }}
						OnClick={ChangeAuthenticationMode}
						buttonType={CustomButtonType.positive}
					/>
				</div>
			</div>
		</div>
	);
};

export default Enhanced( Login,{componentNamespace:"Login"});
